import React from 'react';
import { Box, Container, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';

const PrivacyPolicy: React.FC = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  return (
    <Box bg={bgColor} py={20} minH="100vh">
      <Container maxW="container.lg">
        <Box bg={cardBg} p={10} borderRadius="lg" shadow="md">
          <Heading as="h1" size="2xl" mb={6} color={useColorModeValue('brand.700', 'brand.200')}>
            Privacy Policy
          </Heading>
          
          <VStack align="start" spacing={6}>
            <Text fontSize="lg" color="gray.600" lineHeight="tall">
              At MarketLink, we connect farmers and agro dealers with buyers directly across Zimbabwe. We do not charge commission on sales. Your trust matters to us, so here is how we collect, use and protect your information.
            </Text>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Information We Collect
              </Heading>
              <Text fontSize="md" color="gray.600" mb={2}>
                We only collect what is needed to make the marketplace work:
              </Text>
              <VStack align="start" spacing={2} pl={6} color="gray.600">
                <Text>• <strong>Account Information:</strong> Name, phone number, email address, password and location.</Text>
                <Text>• <strong>Listing Information:</strong> Farm products, agro inputs, agro equipment, quantities, prices and photos.</Text>
                <Text>• <strong>Communication Data:</strong> Messages between buyers and sellers on the platform and support requests.</Text>
              </VStack>
            </Box>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Sharing Your Information
              </Heading>
              <Text fontSize="md" color="gray.600" mb={2}>
                Because we connect users directly with others:
              </Text>
              <VStack align="start" spacing={2} pl={6} color="gray.600">
                <Text>• Your name, phone number, email address, location and listing details are visible to other users so that they can contact you directly.</Text>
                <Text>• For legal reasons, we may disclose information if required by Zimbabwean Law, including the Cyber and Data Protection Act (Chapter 11:22). We do not charge commission and we do not share your data for advertising.</Text>
              </VStack>
            </Box>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Children's Privacy
              </Heading>
              <Text fontSize="md" color="gray.600">
                Our platform is for users aged 18 years and above. We do not knowingly collect data from children.
              </Text>
            </Box>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Changes To This Policy
              </Heading>
              <Text fontSize="md" color="gray.600">
                If we update this policy, we will post the new date at the top.
              </Text>
            </Box>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Contact Us
              </Heading>
              <Text fontSize="md" color="gray.600" mb={2}>
                If you have questions about this Privacy Policy, contact us:
              </Text>
              <VStack align="start" spacing={1} pl={6} color="gray.600">
                <Text><strong>MarketLink</strong></Text>
                <Text>Email: Support@marketlink.co.zw</Text>
                <Text>Phone: 0775 116 054 / 0783 006 221</Text>
                <Text>Address: 5808 Hadzinamhanga Rd, Seke, Chitungwiza</Text>
              </VStack>
            </Box>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
